<div class="heading">
    <div class="heading-trans">
        <div class="heading-copy pt-4">
            <h2 class="mb-0">Please wait</h2>
            <h4 class="mt-4">Checking your information..</h4>
        </div>
    </div>
</div>

<p>
  We're just validating the information you gave us - won't be a sec!
</p>